<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取账号信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			account_info接口提供了获取当前账号注册邮箱、手机号、企业名称、真实姓名、详细地址、所属行业及所在地等信息的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/account_info">https://skfrm.cn/APIV2/account_info</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-Value-New :propsTableData='frmReturnValueNew'></frm-Return-Value-New>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"data":
		{
			"email":"2186345474@qq.com",
			"phone":"17316290890",
			"name":"蔡志伟",
			"address":"北环中心1008",
			"industry":"机器人",
			"company":"盛开互动科技有限公司",
			"location":"北京市,朝阳区"
		}
	}
失败：
	{
		"error_code":"1004",
		"error_msg":"account_id无效"
	}
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnValueTableNew from '../../../../components/frmReturnValueTableNew';
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,
			'frm-Return-Value-New':FrmReturnValueTableNew,
			'frm-Error-Code':FrmErrorCodeTable,
		},
		data(){
			return{
				isPathData:['FRM API-v2','账号登录','获取账号信息'],
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
				],
				frmReturnValueNew:[
					{
						"Parameter":"error_code",
						"name":"string",
						"msg":"0 成功  1 失败",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"error_msg",
						"name":"string",
						"msg":"成功返回 success  失败返回 fail",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"返回账号信息结构",
						"rowspan":8,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"email string 账号注册邮箱",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"phone string 账号注册手机号",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"name    string     账号注册人姓名",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"address    string     公司地址",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"industry    string     公司所属行业",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"company    string     公司名称",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"location    string     公司所在省市",
					},
				],
				frmErrorCode:[
					{"Statuscode":"1","errormessage":"fail","msg":"服务器繁忙"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/AccountSettings/GettingAccountInformation.vue